import {
  Organization,
  OrganizationContextProps,
} from '@foxtrotplatform/platform-micro-site-core';

export enum TenantOnboardingStatus {
  OPEN = 'OPEN',
  APPROVED = 'APPROVED',
  DECLINED = 'DECLINED',
  IN_PROGRESS = 'IN_PROGRESS',
  TIMED_OUT = 'TIMED_OUT',
  FAILED = 'FAILED',
  SUCCESS = 'SUCCESS',
}

export interface Tenant {
  uniqueCode: string;
  coreosClientId: string;
  coreosClientSecretId: string;
  createdAt: number;
  createdBy: string;
  dnsEntry: string;
  isActive: boolean;
  onboardingStatus: TenantOnboardingStatus;
  orgId: string;
  orgName: string;
  updatedAt: number;
  updatedBy: string;
}

export interface DeveloperOrganization extends Organization {
  email: string;
  website: string;
  domain: string;
  country: string;
}

export interface DeveloperOrganizationContextProps
  extends OrganizationContextProps {
  currentOrg?: DeveloperOrganization;
  currentTenant?: Tenant;
  userEmailDomainOrg?: Organization;
  requiresOrgOnboarding: boolean;
  refreshOrganizations: () => void;
  refreshOrganizationTenant: () => void;
}
